import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUtensils,faMapMarkerAlt, faCoffee, faMedal, faDiceFive, faTint, faStarOfDavid, faSpa } from "@fortawesome/free-solid-svg-icons";
import 'react-responsive-modal/styles.css';
import { withTranslation } from 'react-i18next';

class CardLineHotel extends React.Component {
    constructor (props) {
        super(props);
        /*this.state = {
            'active' : false,
            'open': false,
			'open_covid19': false,
            'data': this.props.data,
            'property_photo': null
        }*/
        //this.handleClick = this.handleClick.bind(this); 
        //this.handleMoreDetailsBtn = this.handleMoreDetailsBtn.bind(this); 
    }

    componentDidMount() {
        // initGA();
     }

    GetMealPlanName = (code) => {
        const { t } = this.props;
        switch(code) {
          case 'HM': return t('hotels.mealPlans.halfBoard'); // Breakfast and half board
          case 'MB': return t('hotels.mealPlans.halfBoardDrinks'); //Half board with drinks
          case 'MP': return t('hotels.mealPlans.halfBoard'); //Half board
          case 'PC': return t('hotels.mealPlans.fullBoard'); //Full board
          case 'PV': return t('hotels.mealPlans.fullBoardDrinks'); //Full board with drinks
          case 'SA': return ''; //Accommodation only
          case 'SP': return ''; //According to programme
          case 'TI': return t('hotels.mealPlans.allInclusive'); //All inclusive
          case 'TP': return t('hotels.mealPlans.allInclusivePremium'); //All inclusive premium
          case 'SC': return ''; //Self Catering
          case 'HD': return t('hotels.mealPlans.breakfast'); //Bed and breakfast
          default: return '';
        }
    };


     render() {
        const { t, i18n } = this.props;
        const currentLang = i18n.language; // 'he', 'en', etc.

        //const backgroundImage = `../images/destinations/${this.props.data.property.city_name}.jpg`; //this.props.data.destination.city_id; //encodeURI(this.props.data.image);
        const hotel_name = this.props.data.property.name
        let hotel_address = this.props.data.property.address
        if (hotel_address.length > 35)
            hotel_address = hotel_address.substring(0,30) + '...'
        const stars_count = this.props.data.property.stars
        const distanceValue = Number(this.props.data.property.distance_from_center);
        let distance_from_center;
        if (distanceValue < 1) {
            distance_from_center = t('hotels.distance.meters', { distance: distanceValue * 1000 });
        } else {
            distance_from_center = t('hotels.distance.kilometers', { distance: distanceValue.toFixed(1) });
        }
        //const hotel_stars_caption = this.props.data.property.stars +' כוכבים'        

        return (
            <div className="card-hotel-container" style={{color:'#333', padding: '0.8em', width:'100%', backgroundColor:'#eee'}} title={t('deals.cardHeader.hotelWithStars', { name: hotel_name, stars: stars_count })}>
                {/*<h3 style={{fontSize:'1.35em', fontWeight:800}}>מלון {hotel_stars_caption}</h3>*/}
                <div style={{display:'flex', flexDirection: 'column'}}>
                    <h4 className="card-hotel-name" style={{fontSize:'1.1em', lineHeight:1, margin:'0 0 0.5em',  overflow:'hidden'}}>{hotel_name}</h4>
                    {/*<p style={{color:'#777',maxWidth:'90%', lineHeight:1, fontSize: '0.8em', fontWeight:400}}>{hotel_address}</p>*/}
                    <div style={{display:'flex', justifyContent: 'space-between'}}>
                        
                        <div className="card-hotel-info-padding">
                            <div className="stars" style={{color:'#daa520', fontSize: '1.2em'}} title={t('filters.stars.starsCount', { count: stars_count })}>{this.getStarsImage(stars_count)}</div>
                            <div className={this.props.data.property.room.breakfast_included?'':'hidden'}>
                                <div style={{fontSize:'0.95em', display:'inline-block', color: '#02badb', fontWeight: 700}} className={'div_breakfast ' + (this.GetMealPlanName(this.props.data.property.meal_code)!==''?'':'hide')}>
                                    <FontAwesomeIcon icon={this.props.data.property?.meal_code=='HD'?faCoffee:faUtensils} style={{display:'inline-block', margin:'0 .3em', fontSize:'0.9em'}} alt={this.GetMealPlanName(this.props.data.property.meal_code)} title={this.GetMealPlanName(this.props.data.property.meal_code)} /> 
                                    {this.GetMealPlanName(this.props.data.property.meal_code)}
                                </div>
                            </div>
                            <div className={this.props.data.property?.has_waterpark?'':'hidden'} style={{color:'#32658a'}}>
                                <FontAwesomeIcon icon={faTint} style={{display:'inline-block', margin:'0 .3em', fontSize:'0.9em'}} alt={t('hotels.amenities.waterPark')} title={t('hotels.amenities.waterPark')} /> 
                                <div style={{fontSize:'0.9em', display:'inline-block', fontWeight: 700}}>{t('hotels.amenities.waterPark')}</div>
                            </div>
                            <div className={this.props.data.property?.has_casino?'':'hidden'} style={{color: '#994545'}}>
                                <FontAwesomeIcon icon={faDiceFive} style={{display:'inline-block',  margin:'0 .3em', fontSize:'0.9em'}} alt={t('hotels.amenities.casino')} title={t('hotels.amenities.casino')} /> 
                                <div style={{fontSize:'0.9em', display:'inline-block', fontWeight: 700}}>{t('hotels.amenities.casino')}</div>
                            </div>
                            <div className={this.props.data.property?.near_chabad && currentLang !='ar' ? '':'hidden'} style={{color: '#0d0d7b'}}>
                                <FontAwesomeIcon icon={faStarOfDavid} style={{display:'inline-block', color: '#0d0d7b', margin:'0 .3em', fontSize:'0.9em'}} alt={t('hotels.amenities.nearChabad')} title={t('hotels.amenities.nearChabad')} /> 
                                <div style={{fontSize:'0.9em', display:'inline-block', fontWeight: 700}}>{t('hotels.amenities.nearChabad')}</div>
                            </div>
                            <div className={this.props.data.property?.has_spa?'':'hidden'} style={{color: '#198754'}}>
                                <FontAwesomeIcon icon={faSpa} style={{display:'inline-block', color: '#198754', margin:'0 .3em', fontSize:'0.9em'}} alt={t('hotels.amenities.spa')} title={t('hotels.amenities.spa')} /> 
                                <div style={{fontSize:'0.9em', display:'inline-block', fontWeight: 700}}>{t('hotels.amenities.spa')}</div>
                            </div>
                            <div style={{display:'flex', textWrapMode:'wrap', textWrap: 'auto', lineHeight:1, margin: '.3em 0'}}>
                                <FontAwesomeIcon icon={faMapMarkerAlt} style={{display:'inline-block', margin:'0 .3em', fontSize:'0.9em'}} alt={distance_from_center+' '+t('hotels.distance.fromCenter')} title={distance_from_center+' '+t('hotels.distance.fromCenter')} />
                                <div style={{fontSize:'0.9em', display:'inline-block'}}>{distance_from_center} {t('hotels.distance.fromCenter')}</div>
                            </div>
                            <div className={this.props.data.property.room.breakfast_included?'hidden':''}>
                                <FontAwesomeIcon icon={faMedal}  style={{display:'inline-block', margin:'0 .3em', fontSize:'0.85em'}}  alt={t('hotels.amenities.popular')} title={t('hotels.amenities.popular')} />
                                <div style={{fontSize:'0.9em', display:'inline-block'}}> {t('hotels.amenities.popular')}</div>
                            </div>
                        </div>
                        <div className='hotelPhoto' style={{backgroundImage: "url(" + (this.props.data.property.photos?`https://cdn.cookiecrumbz.com/images/properties/400/${this.props.data.property.photos[0]}`:'') + ")"}}></div>
                    </div>
                </div>
                

            </div> 
        )
     }

     getStarsImage(num) {
        let output = "";

        for (let i=0;i<num;i++) {
            output+="★";
        }

        return output;
    }

}

export default withTranslation()(CardLineHotel)